/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuSection } from '../../models/menu-section';

export interface GetMenuSectionById$Params {

/**
 * ID sekcie
 */
  id: number;
}

export function getMenuSectionById(http: HttpClient, rootUrl: string, params: GetMenuSectionById$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuSection>> {
  const rb = new RequestBuilder(rootUrl, getMenuSectionById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuSection>;
    })
  );
}

getMenuSectionById.PATH = '/admin/menu/{id}';
